import { CUSTOMER_V2 } from '@api/react-query/keys'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { disconnectLedger, getLedgerConnection } from './endpoints'

export const QueryKeys = {
  LedgerConnection: (customerId: string) => ['ledger-connection', customerId] as const,
  DisconnectLedger: (customerId: string) => ['disconnect-ledger', customerId] as const,
}

export const useLedgerConnection = (customerId: string) => {
  return useQuery({
    queryKey: QueryKeys.LedgerConnection(customerId),
    queryFn: () => getLedgerConnection(customerId),
  })
}

export const useDisconnectLedger = (customerId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: QueryKeys.DisconnectLedger(customerId),
    mutationFn: () => disconnectLedger(customerId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QueryKeys.LedgerConnection(customerId) })
      queryClient.invalidateQueries({ queryKey: [CUSTOMER_V2, customerId] })
    },
  })
}
